module.exports = __webpack_public_path__ + "static/media/img_intersect_light.290c2195.png";